import React from 'react';
import { useDispatch } from 'react-redux';
import { replace as Replace } from 'redux-first-history';
import { Pagination } from '@dev/ee-components';
import { addParamToUrl } from '@/services/tools/handleUrlParams';
import { CampaignByTargetStart } from '@/store/campaigns/actions';
import { getLoadParams } from '../tools/getLoadParams';
import { useQueryParams } from '../hooks/useQueryParams';
import { PaginationComponentProps } from '../TargetCampaignsProps';

export const PaginationComponent = ({ totalCount, name }: PaginationComponentProps): JSX.Element => {
    const dispatch = useDispatch();
    const { search, perPage, page } = useQueryParams();

    const handlePaginationChange = (page: number, perPage: number): void => {
        const newSearch = addParamToUrl({
            page,
            perPage,
        });
        dispatch(Replace({ search: newSearch }));

        const loadParams = {
            name,
            search,
            page,
            perPage,
        };
        const params = getLoadParams(loadParams);
        dispatch(CampaignByTargetStart(params));
    };

    return (
        <Pagination
            activePage={page}
            perPage={perPage}
            dataLength={totalCount}
            handlePaginationChange={(activePage, perPage): void => handlePaginationChange(activePage, perPage)}
            isRecalculatingActivePage={false}
        />
    );
};
